export default {"src":"https://fishbrain.com/_next/static/media/pennsylvania.8ed10eb0.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};